import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';

import router from './router';

import store from './store';

import filters from './utils/filter.js'; // 注册过滤器

import { AXIOSWAYS, ApiInfo } from './utils/server.js';

import Common from './utils/common.js';

import './assets/less/main.less';

Object.keys(filters).forEach(k => { // 注册过滤器
  Vue.filter(k, filters[k])
})

Vue.config.productionTip = false;

Vue.prototype.$axios = AXIOSWAYS;
Vue.prototype.$ApiInfo = ApiInfo;
Vue.prototype.$Common = Common;

Common.initFontSize();
Common.watchFontSize();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
